<template>
    <v-container class="full-height">
        <iframe src="https://reports.lyndus.com.br" width="100%" height="100%" frameborder="0"></iframe>
    </v-container>
</template>

<script>
export default {
    name: "Reports",
};
</script>

<style scoped>
.full-height {
    height: 90vh;
    display: flex;
    flex-direction: column;
}

iframe {
    flex: 1;
    border: none;
}
</style>